export default [
  { shortCode: "AL", name: "Alabama" },
  { shortCode: "AK", name: "Alaska" },
  { shortCode: "AZ", name: "Arizona" },
  { shortCode: "AR", name: "Arkansas" },
  { shortCode: "CA", name: "California" },
  { shortCode: "CO", name: "Colorado" },
  { shortCode: "CT", name: "Connecticut" },
  { shortCode: "DE", name: "Delaware" },
  { shortCode: "DC", name: "District of Columbia" },
  { shortCode: "FL", name: "Florida" },
  { shortCode: "GA", name: "Georgia" },
  { shortCode: "HI", name: "Hawaii" },
  { shortCode: "ID", name: "Idaho" },
  { shortCode: "IL", name: "Illinois" },
  { shortCode: "IN", name: "Indiana" },
  { shortCode: "IA", name: "Iowa" },
  { shortCode: "KS", name: "Kansas" },
  { shortCode: "KY", name: "Kentucky" },
  { shortCode: "LA", name: "Louisiana" },
  { shortCode: "ME", name: "Maine" },
  { shortCode: "MD", name: "Maryland" },
  { shortCode: "MA", name: "Massachusetts" },
  { shortCode: "MI", name: "Michigan" },
  { shortCode: "MN", name: "Minnesota" },
  { shortCode: "MS", name: "Mississippi" },
  { shortCode: "MO", name: "Missouri" },
  { shortCode: "MT", name: "Montana" },
  { shortCode: "NE", name: "Nebraska" },
  { shortCode: "NV", name: "Nevada" },
  { shortCode: "NH", name: "New Hampshire" },
  { shortCode: "NJ", name: "New Jersey" },
  { shortCode: "NM", name: "New Mexico" },
  { shortCode: "NY", name: "New York" },
  { shortCode: "NC", name: "North Carolina" },
  { shortCode: "ND", name: "North Dakota" },
  { shortCode: "OH", name: "Ohio" },
  { shortCode: "OK", name: "Oklahoma" },
  { shortCode: "OR", name: "Oregon" },
  { shortCode: "PA", name: "Pennsylvania" },
  { shortCode: "RI", name: "Rhode Island" },
  { shortCode: "SC", name: "South Carolina" },
  { shortCode: "SD", name: "South Dakota" },
  { shortCode: "TN", name: "Tennessee" },
  { shortCode: "TX", name: "Texas" },
  { shortCode: "UT", name: "Utah" },
  { shortCode: "VT", name: "Vermont" },
  { shortCode: "VA", name: "Virginia" },
  { shortCode: "WA", name: "Washington" },
  { shortCode: "WV", name: "West Virginia" },
  { shortCode: "WI", name: "Wisconsin" },
  { shortCode: "WY", name: "Wyoming" },
  { shortCode: "PR", name: "Puerto Rico" },
  { shortCode: "AS", name: "American Samoa" },
  { shortCode: "GU", name: "Guam" },
  { shortCode: "MP", name: "Northern Mariana Islands" },
  { shortCode: "VI", name: "Virgin Islands" },
  { shortCode: "UM", name: "U.S. Minor Outlying Islands" },
  { shortCode: "FM", name: "Federated States of Micronesia" },
  { shortCode: "MH", name: "Marshall Islands" },
  { shortCode: "PW", name: "Palau" },
  { shortCode: "AB", name: "Alberta" },
  { shortCode: "BC", name: "British Columbia" },
  { shortCode: "MB", name: "Manitoba" },
  { shortCode: "NB", name: "New Brunswick" },
  { shortCode: "NL", name: "Newfoundland and Labrador" },
  { shortCode: "NT", name: "Northwest Territories" },
  { shortCode: "NS", name: "Nova Scotia" },
  { shortCode: "NU", name: "Nunavut" },
  { shortCode: "PE", name: "Prince Edward Island" },
  { shortCode: "SK", name: "Saskatchewan" },
  { shortCode: "ON", name: "Ontario" },
  { shortCode: "QC", name: "Quebec" },
  { shortCode: "YT", name: "Yukon" },
  { shortCode: "BS", name: "Bahamas" },
  { shortCode: "TT", name: "Trinidad &amp; Tobago" },
  { shortCode: "FR", name: "France" },
  { shortCode: "IE", name: "Ireland" },
  { shortCode: "RU", name: "Russia" },
  { shortCode: "ES", name: "Spain" },
  { shortCode: "UK", name: "United Kingdom" },
  { shortCode: "BH", name: "Bahrain" },
  { shortCode: "ISR", name: "Israel" },
  { shortCode: "JO", name: "Jordan" },
  { shortCode: "KW", name: "Kuwait" },
  { shortCode: "LB", name: "Lebanon" },
  { shortCode: "QA", name: "Qatar" },
  { shortCode: "SA", name: "Saudi Arabia" },
  { shortCode: "AE", name: "U.A.E." },
  { shortCode: "CH", name: "China" },
  { shortCode: "HK", name: "Hong Kong" },
];
